// @flow
import React from 'react';
import { Ccn } from 'services/ccnService';

const FilterContext = React.createContext<any>();

type Props = {
    children: any
}

type State = {};

/**
 * FilterProvider
 * @author Tomasz tpr@deltacode.fr
 * @memberof Providers
 * @extends {React.Component}
 * @description Filter provider
 */
class FilterProvider extends React.Component<Props,State> {

    getFilteredCcns = async (body: any) => {
        /**
         * @instance
         * @async
         * @method getFilteredCcns
         * @memberof Providers.FilterProvider
         * @return { Array } filtered CCNS
         */
        try {
            const response =  await Ccn.sort(body);
            const payload = await response.json();
            return payload
        }catch(error){
            throw error
        }
    }
    
    render() {
        /**
         * @instance
         * @method render
         * @memberof Providers.FilterProvider
         * @return { String } JSX 
         */
        return (
            <FilterContext.Provider value={{
                ...this.state,
                getFilteredCcns: this.getFilteredCcns,
            }}>
            {this.props.children}
            </FilterContext.Provider>
        )
    }
}

const FilterConsumer = FilterContext.Consumer

export { FilterProvider, FilterConsumer }